// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getPreparedAudit} from '../../shared/repositories';

export const readPreparedAudit = (auditNumber, accounts) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const accountsArray = typeof accounts === 'string' ? [accounts] : accounts;

        try {

            const data = await getPreparedAudit(auditNumber, accountsArray);

            dispatch({
                data,
                type: actions.UPDATE_TCSM_PREPARE_AUDIT_AUDIT
            });

            dispatch({
                isAuditLoaded: true,
                type: actions.UPDATE_TCSM_PREPARE_AUDIT_IS_AUDIT_LOADED
            });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/action-creators/get-prepared-audit.js